import fetch from '../../../../../utils/fetch'
import * as types from './mutation_types'
import { has, includes, split } from 'lodash'

export const reset = ({ commit }) => {
  commit(types.THUMBNAIL_LIST_RESET)
}

export const getItems = ({ commit, state }, { gameId, page, pageNumber }) => {
  commit(types.THUMBNAIL_LIST_RESET)
  commit(types.THUMBNAIL_LIST_SET_LOADING, true)

  let pageUrl = `thumbnails?game.id=${gameId}`
  if (page) {
    pageUrl = page
  } else if (pageNumber) {
    pageUrl += pageNumber
  }

  return fetch(pageUrl)
    .then(response => response.json())
    .then((data) => {
      commit(types.THUMBNAIL_LIST_SET_ITEMS, { items: data['hydra:member'] })
      commit(types.THUMBNAIL_LIST_SET_VIEW, data['hydra:view'])
      commit(types.THUMBNAIL_LIST_SET_TOTAL_ITEMS, data['hydra:totalItems'])
    })
    .catch((e) => {
      commit(types.THUMBNAIL_LIST_SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.THUMBNAIL_LIST_SET_LOADING, false)
    })
}

export const updateItems = ({ commit, state, dispatch }, { created, deleted, gameId }) => {
  if (created) {
    commit(types.THUMBNAIL_LIST_SET_ITEMS, { created })
    const total = state.totalItems + 1
    commit(types.THUMBNAIL_LIST_SET_TOTAL_ITEMS, total)
    const page = returnNextPage(state)
    if (page) {
      return dispatch('getItems', { gameId, pageNumber: page })
    }
  } else if (deleted) {
    commit(types.THUMBNAIL_LIST_SET_ITEMS, { deleted })
    const total = state.totalItems - 1
    commit(types.THUMBNAIL_LIST_SET_TOTAL_ITEMS, total)
    const page = returnPreviousPage(state)
    if (page) {
      return dispatch('getItems', { gameId, pageNumber: page })
    }
  }
  return Promise.resolve({})
}

const maxItemsPerPage = 30

function returnNextPage (state) {
  const pageNumber = Math.ceil(state.totalItems / maxItemsPerPage)
  const stayOnSamePage = includes(state.view['@id'], `page=${pageNumber}`)
  if (pageNumber > 1 && !stayOnSamePage) {
    return `&page=${pageNumber}`
  }
  return null
}

function returnPreviousPage (state) {
  const hasPaging = has(state.view, 'hydra:first')
  if (hasPaging) {
    const isAMultiple = Number.isInteger(state.totalItems / maxItemsPerPage)
    const currentPageNumber = split(state.view['@id'], 'page=')[1]
    if (isAMultiple) {
      return `&page=${currentPageNumber - 1}`
    }
  }
  return null
}
